import { createEntityAdapter, EntityState } from '@ngrx/entity';

import { BossItem } from '../models';

export const stateName = 'boss';

export interface BossState extends EntityState<BossItem> {
  periodItem: BossItem;
  isLoading?: boolean;
  error?: string;
}

export const sortByYearAndMonth = (a: BossItem, b: BossItem) =>
  b.year.localeCompare(a.year) || b.month.localeCompare(a.month);

export const bossAdapter = createEntityAdapter<BossItem>({
  selectId: (i) => i.period,
  sortComparer: sortByYearAndMonth,
});

export const bossInitialState = bossAdapter.getInitialState({
  periodItem: null,
  isLoading: false,
});
